import { helper } from "@ember/component/helper"
import { isNil, padStart } from "lodash-es"

interface BasicTimeObject {
  hour: number
  minute: number
}

export default function convertTimeToId(time: BasicTimeObject | null): string | null {
  if (isNil(time)) return null
  let { hour, minute } = time
  if (hour == null || minute == null) return null
  return `${hour}:${padStart(minute.toString(), 2, "0")}`
}

// We only have this so we can get typing with glint.
const convertTimeToIdHelper = helper((params: [BasicTimeObject | null]) => {
  return convertTimeToId(params[0])
})

declare module "@glint/environment-ember-loose/registry" {
  export default interface Registry {
    "convert-time-to-id": typeof convertTimeToIdHelper
  }
}
